import type {Rec} from 'src/typings';

export class RecordMergeRequest {

    public constructor(public readonly target: Rec,
                       public readonly sources: Rec[],
                       public readonly mergeDetail?: boolean,
                       public readonly ignoreTargetFondMissingFieldDefinition?: boolean) {
    }
}
